import styled from 'styled-components';
import { BannerProps } from './banner.interface';
import { finspheraTypography } from '../../../UIStyles/variables/typography';
import { blackSphera, greenSp } from '../../../UIStyles/variables/Colors';
import { breakpoints } from '../../../UIStyles/variables/breakpoints';
import { spacing } from '../../../UIStyles/variables/spacing';

export const BannerContainer = styled.div<BannerProps>`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  .banner-copy {
    padding: ${spacing.appPaddingMobile} ${spacing.appPaddingMobile} 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h1,
  h2,
  p {
    margin-bottom: ${spacing.appMarginMobile};
    color: ${blackSphera};
  }

  h1 {
    font-size: ${finspheraTypography.fontSize.xLarge};
    text-align: center;
  }

  h2 {
    font-size: ${finspheraTypography.fontSize.large};
  }

  span {
    color: ${greenSp};
  }

  p {
    font-size: ${finspheraTypography.fontSize.medium};
  }

  img {
    width: 100%;
    display: ${(props) => (props.isImgMobile ? 'initial' : 'none')};
  }

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    .banner-copy {
      padding-left: ${spacing.appPadding};
      padding-right: ${(props) => (props.isImgMobile ? '2rem' : spacing.appPadding)};
      width: 100%;
    }

    h1,
    h2,
    p {
      margin-bottom: ${spacing.appMargin};
    }

    h1 {
      font-size: ${finspheraTypography.fontSize.xxLarge};
    }

    h2 {
      font-size: ${finspheraTypography.fontSize.xLarge};
    }

    p {
      font-size: ${finspheraTypography.fontSize.large};
    }

    img {
      align-self: start;
      width: 55%;
      object-fit: contain;
      border-bottom-left-radius: 45%;
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    justify-content: space-between;

    .banner-copy {
      padding-top: 0;
      padding-right: 2rem;
      align-items: start;
      width: 100%;
    }

    img {
      display: initial;
    }
  }
`;
